module.exports = "<iframe *ngIf=\"loadBi\"\r\n  [src]=\"url\"\r\n  frameborder=\"0\" allowFullScreen=\"true\"></iframe>\r\n\r\n"